import { render } from "./PosReceipt.vue?vue&type=template&id=07fb546f&scoped=true&ts=true"
import script from "./PosReceipt.vue?vue&type=script&lang=ts"
export * from "./PosReceipt.vue?vue&type=script&lang=ts"

import "./PosReceipt.vue?vue&type=style&index=0&id=07fb546f&scoped=true&lang=css"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fb546f"]])

export default __exports__